export const AwaitingReminderTemplate = {
    name: 'reminder',
    label: 'Awaiting reminder',
    subject: "REBIT ${reference}: Reminder to pay ${origin_currency}!",
    category: 'reminders',
    body: "<p>Hi ${payer_name},</p>"
        + "<p>Your Rebit to ${recipient_name} is awaiting a ${paid_amount} ${origin_currency} payment.</p>"
        + "<p style='font-weight: bold'>📤 Payable amount: ${paid_amount} ${origin_currency}</p>"
        + "<p style='padding:10px;background-color:#fffae6'>⚠️ If you haven't made the bank payment yet, please click below to complete your payment immediately.<br>"
        + "☁️ You can also upload bank receipts via Tracking or Payment.</p>"
        + "<p style='padding:20px;text-align: center'>"
        + "<a href='https://my.rebitmoney.com/transfers/pay?ref=${reference}' style='padding:10px;background-color: #000000;color: white;border-radius: 4px;text-decoration: none'>✔️ PAY ${paid_amount} ${origin_currency} NOW</a>"
        + "</p>"
        + "<p>If you didn’t intend to make this transfer, please visit your <a href='https://my.rebitmoney.com/transfers/history'>Transfers History</a> and click on Cancel.</p>"
        + "<p>We’ll process your order as soon as we receive your ${origin_currency} payment.</p>"
}

